<script>
        import * as animateScroll from "svelte-scrollto";
        import { onMount } from 'svelte';
        export let subSelection;
        export let handleInfoBoxClick;

        let open = 1;
        let open2 = 1;

        let handleClickInfoCardOne = () => {
            open = 1;
        }
        let handleClickInfoCardTwo = () => {
            open = 2;
        }
        let handleClickInfoCardThree = () => {
            open = 3;
        }
        let handleClickInfoCardFour = () => {
            open = 4;
        }
        let handleClickInfoCardFive = () => {
            open = 5;
        }
        let handleClickInfoCardSix = () => {
            open = 6;
        }
        let handleClickCertCardOne = () => {
            open2 = 1;
        }
        let handleClickCertCardTwo = () => {
            open2 = 2;
        }
        let handleClickCertCardThree = () => {
            open2 = 3;
        }

        let item1;
        let item2;

        onMount(async () => {
            if(subSelection == 0)  animateScroll.scrollToTop();
            else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
            item1.click();
            item2.click();
        });

    let y, innerHeight;
    let row2, row2Image, calculatedRow2Start, translate2Calculated, conditionRow2;
    let row3, row3Image, calculatedRow3Start, translate3Calculated, conditionRow3;
    let row4, row4Image, calculatedRow4Start, translate4Calculated, conditionRow4;

    $: if (y) {
        calculatedRow2Start = row2.getBoundingClientRect().y - innerHeight/2;
        conditionRow2 = row2Image.getBoundingClientRect().width*0.3 + calculatedRow2Start > 0;
        translate2Calculated = conditionRow2 ? Math.pow(row2Image.getBoundingClientRect().width*0.3 + calculatedRow2Start, 2) : 0;

        calculatedRow3Start = row3.getBoundingClientRect().y - innerHeight/2;
        conditionRow3 = row3Image.getBoundingClientRect().width*0.34 + calculatedRow3Start > 0;
        translate3Calculated = conditionRow3 ? Math.pow(row3Image.getBoundingClientRect().width*0.34 + calculatedRow3Start, 2) : 0;

        calculatedRow4Start = row4.getBoundingClientRect().y - innerHeight/2;
        conditionRow4 = row4Image.getBoundingClientRect().width*0.34 + calculatedRow4Start > 0;
        translate4Calculated = conditionRow4 ? Math.pow(row4Image.getBoundingClientRect().width*0.34 + calculatedRow4Start, 2) : 0;
    }

    import Icon from 'fa-svelte';
    import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
    import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';

    let up1 = true;
    let up2 = true;

    let handleClickArrow1 = () => {
        up1 = !up1;
        up2 = true;
    }
    let handleClickArrow2 = () => {
        up2 = !up2;
        up1 = true;
    }

</script>

<svelte:window bind:scrollY={y} bind:innerHeight={innerHeight}/>

<div class="row" id="container-width">

    <div class="col-12 section-size white-bg">
        <img src="./img/background-A.svg" alt="" class="background-right disabe-img" style="height: 100vh;">
        <div class="row">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="title-content section-cvs" style="margin: 20px 0 0 0;">CATEGORÍAS</h2>
                <hr class="underline-content">
                <p class="text-content">
                    La CVS evalúa el desempeño sustentable de los proyectos en 6 categorías:
                </p>
                <div class="info-icon-container">
                    <div class="box">
                        <img bind:this={item1} on:click={handleClickInfoCardOne} class="car-img-size clickable {open === 1 ? 'selected-box border-color-one' : ''}" src="./img/icon1-C.svg" alt="">
                        <img on:click={handleClickInfoCardTwo} class="car-img-size clickable {open === 2 ? 'selected-box border-color-two' : ''}" src="./img/icon2-C.svg" alt="">
                        <img on:click={handleClickInfoCardThree} class="car-img-size clickable {open === 3 ? 'selected-box border-color-three' : ''}" src="./img/icon3-C.svg" alt="">
                        <img on:click={handleClickInfoCardFour} class="car-img-size clickable {open === 4 ? 'selected-box border-color-four' : ''}" src="./img/icon4-C.svg" alt="">
                        <img on:click={handleClickInfoCardFive} class="car-img-size clickable {open === 5 ? 'selected-box border-color-five' : ''}" src="./img/icon5-C.svg" alt="">
                        <img on:click={handleClickInfoCardSix} class="car-img-size clickable {open === 6 ? 'selected-box border-color-six' : ''}" src="./img/icon6-C.svg" alt="">
                    </div>
                </div>

            </div>

            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix" >
                <div id="accordion" style="margin:2vh 0;" class="fixed-card-height">
                    {#if open == 1}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingOne" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header" >
                                  SALUD Y BIENESTAR
                              </p>
                            </h2>
                          </div>
                          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                            <div class="card-body">
                               <p class="text-content" >
                                Promueve ambientes interiores confortables que contribuyen a la 
                                buena salud y el bienestar físico y psicológico de sus ocupantes.

                            </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open == 2}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingTwo" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  ENERGÍA
                              </p>
                            </h2>
                          </div>
                          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                            <div class="card-body">
                                  <p class="text-content">
                                        Promueve la eficiencia energética en temas como calefacción, 
                                        enfriamiento, iluminación artificial y uso de energías renovables no convencionales.
                                  </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open == 3}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingThree" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  AGUA
                              </p>
                            </h2>
                          </div>
                          <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordion">
                            <div class="card-body">
                                  <p class="text-content">
                                    Promueve el abastecimiento, calidad, consumo y reutilización 
                                    del agua de manera responsable, de acuerdo con la realidad hídrica de la zona.
                                  </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open == 4}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingFour" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  MATERIALES Y RESIDUOS
                              </p>
                            </h2>
                          </div>
                          <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordion">
                            <div class="card-body">
                                  <p class="text-content">
                                        Promueve el uso eficiente de materiales de construcción 
                                        con atributos sustentables, junto con la gestión de
                                        residuos durante la construcción y operación.
                                   </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open == 5}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingFive" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  IMPACTOS AMBIENTALES
                              </p>
                            </h2>
                          </div>
                          <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordion">
                            <div class="card-body">
                                  <p class="text-content">
                                        Promueve la minimización de impactos producidos por la 
                                        construcción hacia la atmósfera, el suelo y los ecosistemas.
                                  </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open == 6}
                        <div class="card" style="margin-bottom:2%;">
                          <div class="card-header" id="headingSix" style="padding:0;">
                            <h2 class="text-align-center" style="margin:0;padding:0;">
                              <p class="dropdown-header">
                                  ENTORNO INMEDIATO
                              </p>
                            </h2>
                          </div>
                          <div id="collapseSix" class="collapse show" aria-labelledby="headingSix" data-parent="#accordion">
                            <div class="card-body">
                                  <p class="text-content">
                                        Promueve proyectos residenciales con buena 
                                        conectividad al transporte y servicios, además de un diseño 
                                        respetuoso con el entorno y la integración cultural.
                                  </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                </div>
            </div>

            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix" >
                <p class="text-content text-width-5">
                Para más información sobre los requerimientos mínimos del nivel de entrada de la CVS,
                <span on:click={handleInfoBoxClick()} class="link-color clickable link-border">haz click aquí</span>
                </p>
            </div>

        </div>
    </div>
    <div class="col-12 section-size white-bg" bind:this={row2} id="about-section-1">
        <img src="./img/background-B.svg" alt="" class="background-left disabe-img bg-niveles">
        <div id="medal"><img bind:this={row2Image} class="img-info-base02 disabe-img" src="./img/information/placa-web.png" alt="" style="{row2Image ? `transform: translateX(${translate2Calculated/1700}px) rotate(${translate2Calculated/7000}deg)` : ''}"></div>
        <div class="row">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="title-content title-margin">NIVELES DE CERTIFICACIÓN</h2>
                <hr class="underline-content">
                <p class="text-content text-width-5">A través de la CVS es posible evaluar la correcta
                                implementación de más de 70 requerimientos de sustentabilidad, los que pueden ser
                                aplicados al diseño y construcción de viviendas. <br><br>
                                Existen requerimientos obligatorios y voluntarios,
                                estos últimos otorgan puntaje, cuyo máximo es 100. <br> <br>
                                El sistema cuenta con tres niveles de certificación que
                                se aplican bajo el siguiente esquema:
                </p>
            </div>
        </div>
        <div class="row" style="margin-bottom: 3vh;">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <div class="img-set">
                    <img bind:this={item2} on:click={handleClickCertCardOne} class="cert-img-size clickable {open2 === 1 ? 'selected-box border-color-seven' : ''}" src="./img/information/sello-certificado.svg" alt="">
                    <img on:click={handleClickCertCardTwo} class="cert-img-size cert-middle-img clickable middle-img {open2 === 2 ? 'selected-box border-color-eight' : ''}" src="./img/information/sello-destacado.svg" alt="">
                    <img on:click={handleClickCertCardThree} class="cert-img-size clickable {open2 === 3 ? 'selected-box border-color-nine' : ''}" src="./img/information/sello-sobresaliente.svg" alt="">
                </div>
                <div id="accordionTwo" style="margin:2vh 0;" class="fixed-card-height">
                    {#if open2 == 1}
                        <div class="card text-width-7" style="margin-bottom:2vh;">
                          <div class="card-header" id="headingSeven" style="padding:0;">
                            <h2 style="margin:0;padding:0;">
                              <p class="dropdown-header" style="white-space: pre-wrap;">
                                  PROYECTO CERTIFICADO SUSTENTABLE
                              </p>
                            </h2>
                          </div>
                          <div id="collapseSeven" class="collapse show" aria-labelledby="headingSeven" data-parent="#accordionTwo">
                            <div class="card-body">
                              <p class="text-content">Aquel que cumple con todos los requerimientos obligatorios de acuerdo con su macrozona.</p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open2 == 2}
                        <div class="card text-width-7" style="margin-bottom:2vh;">
                          <div class="card-header" id="headingEight" style="padding:0;">
                            <h2 style="margin:0;padding:0;">
                              <p class="dropdown-header" style="white-space: pre-wrap;">
                                  PROYECTO DESTACADO SUSTENTABLE
                              </p>
                            </h2>
                          </div>
                          <div id="collapseEight" class="collapse show" aria-labelledby="headingEight" data-parent="#accordionTwo">
                            <div class="card-body">
                              <p class="text-content">
                                  Aquel que cumple con todos los requerimientos obligatorios de acuerdo con su macrozona y, además,
                                  obtiene un puntaje entre 30
                                  y 59,5.
                              </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                    {#if open2 == 3}
                        <div class="card text-width-7" style="margin-bottom:2vh;">
                          <div class="card-header" id="headingNine" style="padding:0;">
                            <h2 style="margin:0;padding:0;">
                              <p class="dropdown-header" style="white-space: pre-wrap;">
                                  PROYECTO SOBRESALIENTE SUSTENTABLE
                              </p>
                            </h2>
                          </div>
                          <div id="collapseNine" class="collapse show" aria-labelledby="headingNine" data-parent="#accordionTwo">
                            <div class="card-body">
                                <p class="text-content">
                                    Aquel que cumple con todos los requerimientos obligatorios de acuerdo con su macrozona y,
                                    además, obtiene un puntaje igual o mayor que 60.
                                </p>
                            </div>
                          </div>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 section-size white-bg" bind:this={row3} id="about-section-2">
        <img src="./img/background-C.svg" alt="" class="background-right disabe-img">
        <img bind:this={row3Image} src="./img/planta-paralaxC-2.png" alt="" class="world02-base04-plant disabe-img" style="{row3Image ? `transform: translateX(${translate3Calculated/1200 - row3Image.getBoundingClientRect().width*0.75}px) rotate(180deg)` : ''}">
        <div class="row" style="padding: 5vh 0;">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-3 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="title-content" style="margin-bottom:2%;">RELACIÓN CON LA CALIFICACIÓN
                                ENERGÉTICA DE VIVIENDAS EN CHILE (CEV)
                </h2>
                <hr class="underline-content">
                <p class="text-content">La Calificación Energética de Viviendas en Chile (CEV)
                    es un instrumento lanzado en 2012, diseñado por el
                    Minvu, en conjunto con el Ministerio de Energía.
                    Entrega información objetiva sobre la eficiencia en el
                    uso de la energía para calefacción, enfriamiento,
                    iluminación, agua caliente sanitaria y energía
                    renovable. <br><br>
                    La CVS, utiliza la herramienta CEV para demostrar el
                    cumplimiento de los siguientes requerimientos
                    obligatorios: confort térmico pasivo y reducción de
                    demanda térmica en viviendas. <br><br>
                    Si quieres conocer más sobre la CEV <a href="https://www.calificacionenergetica.cl/" class="link-color">haz click aquí</a>.
                </p>
                <div class="cev-logo-box">
                    <img src="./img/information/logo-CEV.svg" alt="" class="cev-logo">
                </div>
            </div>
            <div id="col-offset"  class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-3 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-1 padding-fix">
                <h2 class="title-content">RELACIÓN CON LA CERTIFICACIÓN DE
                    EDIFICIO SUSTENTABLE (CES)
                </h2>
                <hr class="underline-content">
                <p class="text-content">La Certificación de Edificio Sustentable (CES), es un
                    sistema nacional lanzado en 2014 y que permite
                    evaluar, calificar y certificar el comportamiento
                    ambiental de edificios de uso público en Chile. <br><br>
                    El Instituto de la Construcción (IC) es el encargado de
                    su desarrollo y mantención, institución que, además,
                    ha participado activamente en los comités Directivo y
                    Técnico de la CVS. <br><br>
                    Ambas certificaciones son homólogas: CVS se aplica
                    en viviendas y CES en edificios de uso público. <br><br>
                    Durante su desarrollo la CVS ha adoptado conceptos
                    de CES, con el fin de facilitar y promover el uso de
                    ambas herramientas a través de un lenguaje común. <br><br>
                    Si quieres conocer más sobre la Certificación de
                    Edificio Sustentable <a href="https://www.certificacionsustentable.cl/" class="link-color">haz click aquí</a>.
                </p>
                <div style="text-align: center;">
                    <img src="./img/information/logo-CES.svg" alt="" style="width:40%;">
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 section-size white-bg" bind:this={row4} id="about-section-3">
        <img src="./img/background-D.svg" alt="" class="background-left disabe-img" style="height: 97vh;">
        <div class="row" style="padding: 1% 0;">

            <img bind:this={row4Image} id="credential" class="img-info-base04 disabe-img" src="./img/information/credencial.png" alt="" style="{row4Image ? `transform: translateX(${-translate4Calculated/2000}px)` : ''}">

            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-4 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <h2 class="title-content title-margin">ACREDITACIÓN DE ASESORES PARA LA CERTIFICACIÓN</h2>
                <hr class="underline-content">
                <p class="text-content">
                    Para asegurar un adecuado proceso de certificación,
                    se ha definido como obligatoria la participación de un
                    profesional acreditado, denominado Asesor CVS. <br><br>
                    Un Asesor CVS es un profesional del área de la
                    construcción sustentable que cuenta con la
                    experiencia y conocimientos necesarios para
                    coordinar con el equipo de proyecto (arquitectura,
                    instalaciones sanitarias, eléctricas, paisajismo, etc.) el
                    cumplimiento de los requerimientos de la
                    certificación.
                </p>
            </div>

            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-6 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <div id="accordionThree" class="flex-arrow">
                    <div class="card">
                        <div on:click={handleClickArrow1} class="card-header clickable" id="headingListOne" style="padding:0;" data-toggle="collapse" data-target="#collapseListOne" aria-expanded="true" aria-controls="collapseListOne">
                            <h2 style="margin:0;padding:0;">
                              <button class="btn btn-link dropdown-header" style="white-space: pre-wrap;">
                                    SUS PRINCIPALES RESPONSABILIDADES SON:
                              </button>
                              <div class="sort-arrow" >
                                  {#if up1 === false}<Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                  {#if up1 === true}<Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                              </div>
                            </h2>
                        </div>

                        <div id="collapseListOne" class="collapse" aria-labelledby="headingListOne" data-parent="#accordionThree">
                          <div class="card-body">
                                <ul class="list-content remove-padding">
                                    <li>Asesorar al mandante respecto de los procedimientos necesarios para certificar un proyecto de vivienda.</li>
                                    <li>Apoyar y coordinar el trabajo del equipo de proyecto para cumplir con los requerimientos de la CVS.</li>
                                    <li>Recopilar la documentación necesaria para demostrar que el proyecto cumple con los requerimientos de la CVS.</li>
                                    <li>Enviar la documentación a revisión a través de la Plataforma Técnica CVS.</li>
                                </ul>
                          </div>
                        </div>
                    </div>
                    <div class="card">
                        <div on:click={handleClickArrow2} class="card-header clickable" id="headingListTwo" style="padding:0;" data-toggle="collapse" data-target="#collapseListTwo" aria-expanded="true" aria-controls="collapseListTwo">
                            <h2 style="margin:0;padding:0;">
                              <button class="btn btn-link dropdown-header" style="white-space: pre-wrap;">
                                PARA ACREDITARSE COMO ASESOR, UN PROFESIONAL DEBERÁ:
                              </button>
                              <div class="sort-arrow" >
                                  {#if up2 === false}<Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                  {#if up2 === true}<Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                              </div>
                            </h2>
                        </div>

                        <div id="collapseListTwo" class="collapse" aria-labelledby="headingListTwo" data-parent="#accordionThree">
                          <div class="card-body">
                              <ol class="ordered-list">
                                  <li>Participar de un proceso de entrenamiento a través de un curso validado por los administradores de la certificación (CTeC).</li>
                                  <li>Rendir una prueba de conocimientos mínimos.</li>
                                  <li>Cumplir con los siguientes requisitos obligatorios: <br>
                                    <ul class="list-content">
                                        <li>
                                            Profesión asociada al área: arquitecto, ingeniero civil en obras civiles,
                                            ingeniero con espacialidad en climatización, ingeniero ambiental,
                                            constructor civil, técnico en construcción o carrera afín, ya sea que los
                                            estudios se hayan cursado en Chile o en el extranjero.
                                        </li>
                                        <li>
                                            Presentar experiencia laboral de, a lo menos, tres años desde la fecha
                                            de titulación, ya sea en Chile o en el extranjero.
                                        </li>
                                    </ul>
                                  </li>
                                  <li>Cumplir con uno de los siguientes requisitos:<br>
                                    <ul class="list-content">
                                        <li>
                                            Tener experiencia demostrable en asesorías en sustentabilidad o
                                            eficiencia energética para proyectos de edificación que en total sumen,
                                            a lo menos, 2.000 m², o para, al menos, tres proyectos.
                                        </li>
                                        <li>
                                            Tener estudios de postítulo (diplomado, magíster, doctorado) en temas
                                            asociados a sustentabilidad en construcción, ya sea en Chile o en el
                                            extranjero.
                                        </li>
                                    </ul>
                                  </li>
                              </ol>
                          </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-4 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">
                <p class="text-content">
                    Se recomienda a quienes estén interesados en
                    acreditarse como Asesores CVS, que también se
                    acrediten como Evaluadores Energéticos de la
                    Calificación Energética de Viviendas. <a class="link-color" href="https://www.calificacionenergetica.cl/proceso-de-acreditacion-de-evaluadores/">Infórmate aquí</a>. <br><br>
                    Para información actualizada sobre cursos de
                    capacitación disponibles, <a href="/#/news" class="link-color">haz click aquí</a>.
                </p>
            </div>
        </div>
    </div>
</div>

<style>

.cev-logo-box{
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
}

.cev-logo{
    width:40%;
}

#collapseOne .text-content,#collapseTwo .text-content,#collapseThree .text-content,#collapseFour .text-content,#collapseFive .text-content,#collapseSix .text-content,#collapseSeven .text-content,#collapseEight .text-content,#collapseNine .text-content{
    margin: 0;
}

.section-size{
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 100%;
}

.card{
    margin:2% 0;
}

.img-info-base02{
    height: 75vh;
    width: 75vh;
    position: absolute;
    right: 104px;
    top: 0;
}

.img-info-base04{
    right: -40vh;
    position: absolute;
    top: -64vh;
    width: 50%;
}

.car-img-size{
    height: 21vh;
}

.white-bg{
    background-color: white;
    overflow: hidden;
}

.text-width-5{
    width: 50%;
}

.text-width-7{
    width: 70%;
}

.padding-fix{
    padding:0 8px;
}

@media (max-width: 1200px){

    .cev-logo-box{
        position: relative;
    }
    .cev-logo{
        padding-bottom:10%;
    }

}

@media (max-width: 1400px){
    .disabe-img {
        display:none;
    }
    .text-width-5{
        width: 100%;
    }
    .padding-fix{
        padding:0 15px;
    }
}

@media (max-width: 1700px){
    .text-width-7{
        width: 100%;
    }
}

.ordered-list{
    line-height: 28px;
    font-family: 'DINPro-Regular' !important;
    text-align: justify;
    padding: 0 5%;
    font-size: 19px;
}

.cert-img-size{
    width: 20vh;
    height: 20vh;
}

.cert-middle-img{
    margin: 0 2%;
}

@media (max-width: 450px){
    .text-align-center{
        text-align:center;
    }
    .cert-middle-img{
        margin: 0;
    }
    .remove-padding{
        padding: 0;
    }
}

.background-right{
    right: 0;
    position: absolute;
    height: 100%;
    /* max-height: 100vh; */
}

.background-left{
    left: 0;
    position: absolute;
    height: 100%;
    /* max-height: 100vh; */
}

.world02-base04-plant{
    position: absolute;
    left: 0;
    transform: scaleX(-1);
    height: 100%;
    z-index: 10;
}

.title-margin{
    margin-top: 5vh;;
}

.dropdown-header{
    font-size: 20pt;
    line-height: 21pt;
    text-align: justify;
    color: rgb(0, 99, 175);
    font-family: 'suga-pro';
    padding: 6px 12px 6px 12px;
}

.card-body{
    padding:1.25rem;;
}

.info-icon-container{
    margin: 0 -10px;
    width: calc(100% + 20px);
    justify-content: space-between;
    text-align: center;
    flex-wrap: wrap;
}

@media (max-width: 1919px){
    .info-icon-container{
        text-align: -webkit-center;
    }
    .info-icon-container .box{
        max-width: 600px;
    }
}

.info-icon-container .car-img-size{
    margin: 10px;
}

.bg-niveles{
    height: 100vh;
}

.card-header{
    background-color: rgb(241,245,234);
}

.fixed-card-height .card{
    height: 200px;
}

@media (max-width: 1400px){
    .fixed-card-height .card{
        height: auto;
    }
    .img-set{
        text-align: center;
    }

}

.selected-box{
    padding: 5px;
}

.selected-box.border-color-one{
    border: 1px solid #f18a00;
    background-color: rgba(241, 138, 0, 0.1);
}
.selected-box.border-color-two{
    border: 1px solid #e0cc00;
    background-color: rgba(224, 205, 4, 0.3);
}
.selected-box.border-color-three{
    border: 1px solid #4196cb;
    background-color: rgba(65, 150, 203, 0.3);
}
.selected-box.border-color-four{
    border: 1px solid #733189;
    background-color: rgba(115, 49, 137, 0.3);
}
.selected-box.border-color-five{
    border: 1px solid #95c11f;
    background-color: rgba(151, 194, 36, 0.3);
}
.selected-box.border-color-six{
    border: 1px solid #026938;
    background-color: rgba(2, 105, 56, 0.3);
}
.selected-box.border-color-seven{
    border: 1px solid #4b8b33;
}
.selected-box.border-color-eight{
    border: 1px solid #4196cb;
}
.selected-box.border-color-nine{
    border: 1px solid #e0cc00;
}

#headingOne{
    background-color: rgba(241, 138, 0, 0.3);
}
#headingTwo{
    background-color: rgba(224, 205, 4, 0.3);
}
#headingThree{
    background-color: rgba(65, 150, 203, 0.3);
}
#headingFour{
    background-color: rgba(115, 49, 137, 0.3);
}
#headingFive{
    background-color: rgba(151, 194, 36, 0.3);
}
#headingSix{
    background-color: rgba(2, 105, 56, 0.3);
}

.sort-arrow {
    margin-left: auto;
}


.sort-arrow :global(.arrow-bot) {
    margin-bottom:13px;
    pointer-events: none;
}

.sort-arrow :global(.arrow-top) {
    margin-top:13px;
    pointer-events: none;
}

.flex-arrow .card-header h2{
    display: flex;
}

.link-color{
    color: #95c121;
}

.link-border.link-color:hover{
    border-bottom:2px solid #95c121;
}

</style>